import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlatroofZoningRooms } from '../model/flatroof-zoning-rooms';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // private _url: string = 'http://localhost/rockwool/zoning/src/api/getData.php';
  private _url: string = location.protocol+'//bimsources.com/zoning/api/getData.php';
  // private _url: string = 'http://test.hybrid.pl/rockwool/zoning/api/getData.php';
  constructor(private _http: HttpClient) { }

  get url(){
      return this._url;
  }

  getData(): Observable<any>{
    return this._http.get<any>(this.url+'?get=zoning_data');
  }

  getRoomsList(): Observable<FlatroofZoningRooms[]>{
    return this._http.get<FlatroofZoningRooms[]>(this.url+'?get=rooms');
  }

  
}
